<template>
    <div>
        <sortData :columns="columns" :request="request" customKey="changeDate" @setSortBy="setSortBy" v-if="withSort"></sortData>
        <div class="r-table">
            <table>

                <theadCustom :columns="columns" :withAction="withAction" :request="request" customKey="changeDateColumn" @setSortBy="setSortBy"></theadCustom>

                <loading v-if="fetchData"/>

                <nodata v-if="isEmpty"></nodata>

                <slot></slot>
            </table>
            <pagination :request="request" :data="data" @setShow="setShow" @getData="getData" v-if="data != null"></pagination>
        </div>
    </div>
</template>
<script>
import loading from '@/components/common/loading.vue'
import nodata from '@/components/common/nodata.vue'
import sortData from './sortData'
import theadCustom from './theadCustom'
import pagination from './paginationCustom'

export default {
    props: {
        columns: {
            require: true
        },
        data: {
            require: false,
            default: null
        },
        request: {
            require: false
        },
        fetchData: {
            require: true
        },
        isEmpty: {
            require: true
        },
        withAction: {
            default: true
        },
        withSort: {
            default: true
        }
    },
    components:{
        loading,
        nodata,
        sortData,
        theadCustom,
        pagination
    },
    methods: {
        setShow(value){
            this.$emit("setShow", value)
        },
        getData(value){
            this.$emit("getData", value)
        },
        setSortBy(value){
            this.$emit("setSortBy", value)
        }
    }
}
</script>